module.exports = __webpack_public_path__ + "static/media/SaoPaulo_kmeans_202_250.5e8bf21f.csv";